/**
 * Take a value, be it primitive, a promise, or a generator, and reduce it down
 * into chunks processable by transactions.
 */

'use strict';

exports.__esModule = true;

var _typeChecks = require('./type-checks');

var DEFAULT_ERROR = new Error('Rejected Promise');

/**
 * If a given value is a promise, wait for it and
 * execute a callback using the error-first convention.
 *
 * @param {any} value - The target value
 * @param {Function} callback - An error-first callback
 */
var nodeify = function nodeify(value, callback) {
  if (!_typeChecks.isPromise(value)) {
    return callback(null, value, true);
  }

  return value.then(function (body) {
    return callback(null, body, true);
  }, function (error) {
    callback(error || DEFAULT_ERROR, null, true);
    throw error;
  });
};

/**
 * Given an iterator, call nodeify sequentially on each iteration
 *
 * @param {Iterator} iterator - An iterable collection
 * @param {Function} callback - An error-first callback
 */

var waterfall = function waterfall(iterator, callback) {
  var start = iterator.next();

  return coroutine(start.value, function step(error, body, complete) {
    // If next.value is a generator, it's possible that it is not complete.
    // When this is the case, do not progress the parent iterator forward
    // until the child completes successfully.
    if (error || !complete) {
      return callback(error, body, complete);
    }

    var next = iterator.next(body);

    callback(error, body, next.done);

    return next.done ? body : coroutine(next.value, step);
  });
};

/**
 * Checks if a given value is a generator. If so, process it sequentially.
 * Otherwise resolve the specific value using `nodeify`.
 *
 * @param {any} value - The compared value
 * @param {Function} callback - An error-first callback
 */
var coroutine = function coroutine(value, callback) {
  return (_typeChecks.isGenerator(value) ? waterfall : nodeify)(value, callback);
};

exports['default'] = coroutine;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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




/*****************
 ** WEBPACK FOOTER
 ** ./~/microcosm/coroutine.js
 ** module id = 194
 ** module chunks = 0
 **/